const module = {
    addListener: ()=>{},
    removeListeners: ()=>{},
    subscribeToTopicAsync: ()=>{
        return Promise.resolve(null);
    },
    unsubscribeFromTopicAsync: ()=>{
        return Promise.resolve(null);
    }
};
export default module;

//# sourceMappingURL=TopicSubscriptionModule.js.map
